export default "__VITE_ASSET__C$qV3cXf__"